<template>
  <article>
    <div class="container justify-center flex pt-8">
      <div class="w-full md:w-3/5 flex flex-wrap">
        <figure>
          <img :src="item.image" :alt="item.title" class="object-contain">
        </figure>

        <section class="w-full py-8">
          <h2 class="page-title" v-text="item.title"/>
          <div class="page-content" v-html="item.description"/>
        </section>

        <section class="w-2/3 text-md font-heading leading-loose">
          <time>
            <div><b>Datum:</b> {{ $moment(item.date).format('ll') }}</div>
            <div><b>Tijdstip:</b> {{ item.start }} tot {{ item.end }}</div>
          </time>
          <div><b>Locatie:</b> {{ item.location }}</div>
        </section>

        <section class="flex flex-row w-full justify-between py-20">
          <nuxt-link :to="prev">
            <font-awesome-icon :icon="['far', 'arrow-left']" class="text-secondary mr-1 sm:mr-4"/>
            Vorig event
          </nuxt-link>
          <nuxt-link :to="next">
            Volgend event
            <font-awesome-icon :icon="['far', 'arrow-right']" class="text-secondary ml-1 sm:ml-4"/>
          </nuxt-link>
        </section>
      </div>
    </div>
  </article>
</template>

<script>
import {mapState} from 'vuex';

export default {
  async fetch({store, params, error}) {
    try {
      await store.dispatch('getPage', params.pathMatch);
    } catch (e) {
      error({statusCode: 404, message: e.message});
    }
  },
  async asyncData({$axios, params, error}) {
    try {
      const {data} = await $axios.get(`events/${params.slug}`);
      return {
        item: data.data,
        prev: data.prev.permalink,
        next: data.next.permalink,
      };
    } catch (e) {
      error({statusCode: e.response.status, message: e.message});
    }
  },
  computed: mapState(['page']),
  head() {
    return {
      title: this.page.meta.title,
      meta: [
        this.page.meta.description
          ? {
            hid: 'description',
            name: 'description',
            content: this.page.meta.description,
          }
          : {},
      ],
    };
  },
};
</script>
